import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchMarkTypeRequest } from "../../../../store/actions";
import { useSelector } from "react-redux";
import axiosMain from "../../../../http/axios/axios_main";
import CustomToast from "../../../../components/Toast";
import { useAuctionDetail } from "../../../../components/common/AunctioneerDeteailProvider";
import { Button, Modal, Table } from "react-bootstrap";
import { useLoader } from "../../../../components/common/Loder/Loder";
import Modals from "../../../../components/common/Modal";

const MaxBidEntryTable = ({
  rows,
  setRows,
  modalRight,
  auctionType,
  getMaxbid,
  formikval,
}) => {
  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    roleCode,
    auction,
  } = useAuctionDetail();

  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();

  const [data, setData] = useState(rows?.length > 0 ? rows : []);
  const [selectedData, setSelectedData] = useState([]);
  const [checked, setChecked] = useState(false);

  const [editing, setEditing] = useState(false);
  const [show, setShow] = useState(false);
  const [handleYes, setHandleYes] = useState(true);

  const [validationErrors, setValidationErrors] = useState({});
  const [validationErrormessages, setValidationErrormessages] = useState([]);
  const [baseUrlEng, setBaseUrlEng] = useState(
    auction === "English" ? "EnglishAuctionMaxBidEntry" : "MaxBidEntry"
  );

  const [openConformaionModalmsg, setOpenConformaionModalmsg] = useState([]);
  const [openConformaionModal, setOpenConformaionModal] = useState(false);

  const [columns, setColumns] = useState([
    // { label: "Lot No", id: "LotNo" },
    { label: "Tea Type", id: "teaTypeName" },
    { label: "Category", id: "categoryName" },
    { label: "Mark", id: "markName" },
    { label: "Grade", id: "gradeName" },
    ...(auctionType === "ENGLISH"
      ? [
          { label: "Invoice No", id: "invoiceNo" },
          { label: "Total Package", id: "totalPackages" },
          { label: "Base Price", id: "basePrice" },
        ]
      : [
          { label: "Base Price for Normal Auction", id: "basePrice" },
          { label: "Base Price for PRS Auction", id: "basePrice" },
          { label: "Price Increment", id: "priceIncrement" },
        ]),
    { label: "LSP/SP", id: "LSP_SP" },
    ...(auctionType === "ENGLISH"
      ? [
          { label: "SQ (Sharing Qty.)", id: "sharingQty" },
          {
            label: "BQ@HBP (Buying Qty. @ Highest Bid Price)",
            id: "buyingQty",
          },
          {
            label: "MAQ@HBP (Min. Acceptable Qty. @ Highest Bid Price)",
            id: "minAcceptableQty",
          },
          { label: "Auto Bid Limit (AB)", id: "AutoBidLimit" },
          { label: "Limit Price (LP)", id: "LimitPrice" },
        ]
      : [
          { label: "Interested To Bid", id: "interestedToBid" },
          { label: "Max Bid", id: "maxBid" },
          { label: "Invoice No", id: "invoiceNo" },
          { label: "Total Packages", id: "totalPackages" },
          { label: "Created By", id: "createdBy" },
          { label: "Last Modified By", id: "lastModifiedBy" },
          { label: "Session Type", id: "sessionTypeName" },
        ]),
    { label: "Status", id: "status" },
    ...(auctionType === "ENGLISH"
      ? [
          { label: "Created By", id: "createdBy" },
          { label: "Last Modified By", id: "lastModifiedBy" },
          { label: "Session Type", id: "sessionTypeName" },
        ]
      : []),
  ]);

  const dispatch = useDispatch();
  const handleClose = () => {
    setShow(false);
    setHandleYes(true);
  };

  useEffect(() => {
    setData(rows);
  }, [rows]);

  useEffect(() => {
    if (formikval?.sessionType === "0") {
      setColumns([
        // { label: "Lot No", id: "LotNo" },
        { label: "Tea Type", id: "teaTypeName" },
        { label: "Category", id: "categoryName" },
        { label: "Mark", id: "markName" },
        { label: "Grade", id: "gradeName" },
        ...(auctionType === "ENGLISH"
          ? [
              { label: "Invoice No", id: "invoiceNo" },
              { label: "Total Package", id: "totalPackages" },
              { label: "Base Price", id: "basePrice" },
            ]
          : [
              { label: "Base Price for Normal Auction", id: "basePrice" },
              { label: "Base Price for PRS Auction", id: "basePrice" },
              { label: "Price Increment", id: "priceIncrement" },
            ]),
        { label: "LSP/SP", id: "LSP_SP" },
        ...(auctionType === "ENGLISH"
          ? [
              { label: "SQ (Sharing Qty.)", id: "sharingQty" },
              {
                label: "BQ@HBP (Buying Qty. @ Highest Bid Price)",
                id: "buyingQty",
              },
              {
                label: "MAQ@HBP (Min. Acceptable Qty. @ Highest Bid Price)",
                id: "minAcceptableQty",
              },
              { label: "Auto Bid Limit (AB)", id: "AutoBidLimit" },
              { label: "Limit Price (LP)", id: "LimitPrice" },
            ]
          : [
              { label: "Interested To Bid", id: "interestedToBid" },
              { label: "Max Bid", id: "maxBid" },
              { label: "Invoice No", id: "invoiceNo" },
              { label: "Total Packages", id: "totalPackages" },
              { label: "Created By", id: "createdBy" },
              { label: "Last Modified By", id: "lastModifiedBy" },
              { label: "Session Type", id: "sessionTypeName" },
            ]),
        { label: "Status", id: "status" },
        ...(auctionType === "ENGLISH"
          ? [
              { label: "Created By", id: "createdBy" },
              { label: "Last Modified By", id: "lastModifiedBy" },
              { label: "Session Type", id: "sessionTypeName" },
            ]
          : []),
      ]);
    } else if (formikval?.sessionType === "2") {
      setColumns([
        // { label: "Lot No", id: "LotNo" },
        { label: "Tea Type", id: "teaTypeName" },
        { label: "Category", id: "categoryName" },
        { label: "Mark", id: "markName" },
        { label: "Grade", id: "gradeName" },
        ...(auctionType === "ENGLISH"
          ? [
              { label: "Invoice No", id: "invoiceNo" },
              { label: "Total Package", id: "totalPackages" },
              { label: "Base Price", id: "basePrice" },
            ]
          : [
              // { label: "Base Price for Normal Auction", id: "basePrice" },
              { label: "Base Price for PRS Auction", id: "basePrice" },
              { label: "Price Increment", id: "priceIncrement" },
            ]),
        { label: "LSP/SP", id: "LSP_SP" },
        ...(auctionType === "ENGLISH"
          ? [
              { label: "SQ (Sharing Qty.)", id: "sharingQty" },
              {
                label: "BQ@HBP (Buying Qty. @ Highest Bid Price)",
                id: "buyingQty",
              },
              {
                label: "MAQ@HBP (Min. Acceptable Qty. @ Highest Bid Price)",
                id: "minAcceptableQty",
              },
              { label: "Auto Bid Limit (AB)", id: "AutoBidLimit" },
              { label: "Limit Price (LP)", id: "LimitPrice" },
            ]
          : [
              { label: "Interested To Bid", id: "interestedToBid" },
              { label: "Max Bid", id: "maxBid" },
              { label: "Invoice No", id: "invoiceNo" },
              { label: "Total Packages", id: "totalPackages" },
              { label: "Created By", id: "createdBy" },
              { label: "Last Modified By", id: "lastModifiedBy" },
              { label: "Session Type", id: "sessionTypeName" },
            ]),
        { label: "Status", id: "status" },
        ...(auctionType === "ENGLISH"
          ? [
              { label: "Created By", id: "createdBy" },
              { label: "Last Modified By", id: "lastModifiedBy" },
              { label: "Session Type", id: "sessionTypeName" },
            ]
          : []),
      ]);

      console.log(formikval?.sessionType);
      debugger;
    } else {
      setColumns([
        // { label: "Lot No", id: "LotNo" },
        { label: "Tea Type", id: "teaTypeName" },
        { label: "Category", id: "categoryName" },
        { label: "Mark", id: "markName" },
        { label: "Grade", id: "gradeName" },
        ...(auctionType === "ENGLISH"
          ? [
              { label: "Invoice No", id: "invoiceNo" },
              { label: "Total Package", id: "totalPackages" },
              { label: "Base Price", id: "basePrice" },
            ]
          : [
              { label: "Base Price for Normal Auction", id: "basePrice" },
              // { label: "Base Price for PRS Auction", id: "basePrice" },
              { label: "Price Increment", id: "priceIncrement" },
            ]),
        { label: "LSP/SP", id: "LSP_SP" },
        ...(auctionType === "ENGLISH"
          ? [
              { label: "SQ (Sharing Qty.)", id: "sharingQty" },
              {
                label: "BQ@HBP (Buying Qty. @ Highest Bid Price)",
                id: "buyingQty",
              },
              {
                label: "MAQ@HBP (Min. Acceptable Qty. @ Highest Bid Price)",
                id: "minAcceptableQty",
              },
              { label: "Auto Bid Limit (AB)", id: "AutoBidLimit" },
              { label: "Limit Price (LP)", id: "LimitPrice" },
            ]
          : [
              { label: "Interested To Bid", id: "interestedToBid" },
              { label: "Max Bid", id: "maxBid" },
              { label: "Invoice No", id: "invoiceNo" },
              { label: "Total Packages", id: "totalPackages" },
              { label: "Created By", id: "createdBy" },
              { label: "Last Modified By", id: "lastModifiedBy" },
              { label: "Session Type", id: "sessionTypeName" },
            ]),
        { label: "Status", id: "status" },
        ...(auctionType === "ENGLISH"
          ? [
              { label: "Created By", id: "createdBy" },
              { label: "Last Modified By", id: "lastModifiedBy" },
              { label: "Session Type", id: "sessionTypeName" },
            ]
          : []),
      ]);
    }
  }, [formikval?.sessionType]);
  const handleCheckboxChange = (id) => {
    const isChecked = selectedData.some((item) => item.LotNo === id);

    // If the checkbox is checked, remove the data from selectedData
    setSelectedData(selectedData.filter((item) => item.LotNo !== id));
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const handleAdd = (massage) => {
    let totalPackages = data.map((ele) => ele.totalPackages);
    let minAcceptableQty = data.map((ele) => ele.minAcceptableQty);
    let AutoBidLimit = data.map((ele) => ele.AutoBidLimit);
    let validateModal = data.map((ele, index) =>
      parseFloat(ele.LimitPrice) < AutoBidLimit?.at(index) ? ele.LotNo : ele
    );
    let valiDateData = data
      ?.filter((ele) => parseInt(ele.buyingQty) !== 0)
      ?.map((ele, index) =>
        parseInt(ele.buyingQty) <= totalPackages?.at(index) &&
        parseInt(ele.buyingQty) >= minAcceptableQty?.at(index)
          ? ele
          : ele
      );

    if (
      valiDateData?.filter(
        (ele) => ele.AutoBidLimit === 0 && ele.buyingQty === 0
      )?.length > 0
    ) {
      CustomToast?.error("Please enter offline bid in atleast one Lot.");
    } else if (
      data
        ?.filter((ele) => ele.status === "Submitted")
        ?.filter(
          (ele) =>
            parseInt(ele.AutoBidLimit) === 0 && parseInt(ele.buyingQty) === 0
        )?.length > 0
    ) {
      CustomToast?.error(
        "BQ@HBP cannot be ZERO in Lot No. (" +
          data
            ?.filter((ele) => ele.status === "Submitted")
            ?.filter(
              (ele) =>
                parseInt(ele.AutoBidLimit) === 0 &&
                parseInt(ele.buyingQty) === 0
            )
            // ?.filter((ele) => ele.AutoBidLimit !== 0 && ele.LimitPrice !== 0)
            ?.map((ele) => ele.LotNo)
            ?.join(",") +
          ")"
      );
      handleClose();
    } else if (
      data?.filter(
        (ele) =>
          // (ele.AutoBidLimit > 0 && ele.buyingQty <= 0) ||
          ele.AutoBidLimit <= 0 && ele.buyingQty > 0
      )?.length > 0 ||
      data
        ?.filter((ele) => ele.status === 1)
        ?.filter((ele) => ele.AutoBidLimit === 0 && ele.buyingQty === 0)
        ?.length > 0
    ) {
      CustomToast?.error(
        "Please enter Auto Bid limit in lot no. (" +
          data
            ?.filter(
              (ele) =>
                // (ele.AutoBidLimit > 0 && ele.buyingQty <= 0) ||
                ele.AutoBidLimit <= 0 && ele.buyingQty > 0
            )
            // ?.filter((ele) =>ele.AutoBidLimit !== 0 && ele.LimitPrice !== 0)
            ?.map((ele) => ele.LotNo)
            ?.join(",") +
          ")"
      );
      handleClose();
    } else if (
      data?.filter(
        (ele) =>
          (ele.AutoBidLimit > 0 && ele.buyingQty <= 0) ||
          (ele.AutoBidLimit <= 0 && ele.buyingQty > 0)
      )?.length > 0 ||
      data
        ?.filter((ele) => ele.status === 1)
        ?.filter((ele) => ele.AutoBidLimit === 0 && ele.buyingQty === 0)
        ?.length > 0
    ) {
      CustomToast?.error(
        "BQ@HBP cannot be ZERO in Lot No. (" +
          data
            ?.filter(
              (ele) =>
                (ele.AutoBidLimit > 0 && ele.buyingQty <= 0) ||
                (ele.AutoBidLimit <= 0 && ele.buyingQty > 0)
            )
            // ?.filter((ele) => ele.AutoBidLimit !== 0 && ele.LimitPrice !== 0)
            ?.map((ele) => ele.LotNo)
            ?.join(",") +
          ")"
      );
      handleClose();
    } else {
      if (valiDateData?.length === 0) {
        let validate = data
          ?.filter((ele) => parseInt(ele.buyingQty) === 0)
          ?.filter((ele) => ele.AutoBidLimit !== 0 && ele.LimitPrice !== 0)
          ?.map((ele) => ele.LotNo);
        if (validate?.length > 0) {
          CustomToast?.error(
            "BQ@HBP cannot be ZERO in Lot No. (" +
              data
                ?.filter((ele) => parseInt(ele.buyingQty) === 0)
                ?.filter(
                  (ele) => ele.AutoBidLimit !== 0 && ele.LimitPrice !== 0
                )
                ?.map((ele) => ele.LotNo)
                ?.join(",") +
              ")"
          );
        } else {
          CustomToast?.error("Please enter offline bid in atleast one Lot.");
        }

        handleClose();
      } else {
        if (
          valiDateData
            ?.filter((ele) => typeof ele === "string")
            ?.filter((ele) => parseInt(ele.buyingQty) !== 0)?.length > 0
        ) {
          CustomToast.error(
            valiDateData?.map((ele) => ele.LotNo)?.join(" , ") +
              " " +
              "BQ@HBP should always be greater than or equal to MAQ"
          );
          handleClose();
          // //debugger;
        } else {
          openLoader();
          axiosMain
            // .post("/preauction/MaxBidEntry/UpdateMaxBidEntry", savedata)
            .post(
              `/preauction/EnglishAuctionMaxBidEntry/UploadMaxBidEntry?flag=${massage}&validateAction=submit&dataFlag=Menual&season=` +
                formikval.season +
                "&saleNo=" +
                formikval.saleNo,
              valiDateData
                ?.filter((item) => item.flag !== 1)
                ?.filter((items) => items.EditFlag !== 0)
                ?.filter((ele) => typeof ele !== "string")
                ?.map((ele) => {
                  return {
                    ...ele,
                    status: ele.status === "Submitted" ? 1 : 0,
                    createdBy: userId,
                    updatedBy: userId,
                    buyingQty: parseInt(ele.buyingQty),
                    AutoBidLimit:
                      parseInt(ele.AutoBidLimit) === null
                        ? 0
                        : parseInt(ele.AutoBidLimit),
                    auctionCenterId,
                    buyerUserId: userId,
                  };
                })
            )
            .then((response) => {
              closeLoader();
              if (response.data.statusCode === 200) {
                CustomToast.success(response.data.message);
                getMaxbid();
                handleClose();
              } else if (
                (auctionType === "ENGLISH"
                  ? "EnglishAuctionMaxBidEntry"
                  : "MaxBidEntry") === "EnglishAuctionMaxBidEntry" &&
                response.data.statusCode === 423
              ) {
                setOpenConformaionModalmsg(response.data);
                // //debugger;

                setOpenConformaionModal(true);
              } else {
                CustomToast.error(response.data.message);
                handleClose();
                return false;
              }

              // Handle the successful response here
              // console.log("Response:", response.data);
            })
            .catch((error) => {
              // Handle any errors here
              console.error("Error:", error);
              closeLoader();
            });
        }
      }
    }

    // //debugger;
  };
  const savetabledata = () => {
    // console.log(rows, "samardas");

    if (auctionType === "ENGLISH") {
      // savedata now contains only objects where interestedToBid is greater than 0
      let totalPackages = data.map((ele) => ele.totalPackages);
      let minAcceptableQty = data.map((ele) => ele.minAcceptableQty);
      let AutoBidLimit = data.map((ele) => ele.AutoBidLimit);
      let validateModal = data.map((ele, index) =>
        parseFloat(ele.LimitPrice) < AutoBidLimit?.at(index) ? ele.LotNo : ele
      );
      let valiDateData = data.map((ele, index) =>
        parseInt(ele.buyingQty) <= totalPackages?.at(index) &&
        parseInt(ele.buyingQty) >= minAcceptableQty?.at(index)
          ? ele
          : ele.LotNo
      );
      if (validateModal.filter((ele) => typeof ele === "string").length > 0) {
        // CustomToast.error(
        //   valiDateData.filter((ele) => typeof ele === "string").join(",")
        // );
        setShow(true);
        // // console.log(validateModal, "Insert max bid data2");
      } else {
        // // console.log(
        //   valiDateData.filter((ele) => typeof ele !== "string"),
        //   "Insert max bid data"
        // );

        handleAdd(false);
      }

      // console.log(
      // data.map((ele, index) =>
      //   parseInt(ele.buyingQty) < totalPackages?.at(index) &&
      //   parseInt(ele.buyingQty) > minAcceptableQty?.at(index)
      //     ? ele
      //     : ele.LotNo
      // ),
      //   valiDateData.filter((ele) => typeof ele !== "string"),
      //   valiDateData.filter((ele) => typeof ele === "string"),
      //   "Insert max bid data"
      // );
    } else {
      // let vadationDetails = [];
      // vadationDetails.push(validationErrormessages);

      // console.log()
      let savedata = [];

      // data.map((items) => {
      //   const Newdatas={
      //     SaleProgramId:parseInt(items.SaleProgramId),
      //         auctionCenterId:2,
      //         kutchaCatalogId: parseInt(items.KutchaCatalogId),
      //         sessionTypeId: parseInt(items.sessionTypeId),
      //         teaTypeId: parseInt(items.teaTypeId),
      //         categoryId: parseInt(items.categoryId),
      //         markId: parseInt(items.markId),
      //         gradeId: parseInt(items.gradeId),
      //         invoiceId: parseInt(items.invoiceId),
      //         auctionCatalogId: parseInt(items.auctionCatalogId),
      //         interestedToBid:parseInt(items.interestedToBid),
      //         maxBid:parseInt(items.maxBid),
      //         isActive:true,
      //         createdBy:1,
      //         updatedBy: userId,
      //         buyerUserId:userId,
      //         status:1,//parseInt(items.status),
      //         LotNo: items.LotNo

      //   }
      //   savedata.push(Newdatas);

      // });
      // // console.log(data.filter((items) => parseInt(items.maxBidId) === 0 ? parseInt(items.interestedToBid) !== 0 : items),"datadata")
      // //debugger;
      if (
        data
          .map(
            (ele) =>
              (ele.maxBid === "" || ele.maxBid === null) &&
              parseInt(ele.interestedToBid) === 1
          )
          .includes(true)
      ) {
        const rowinvalid = data
          .map(
            (ele, index) =>
              (ele.maxBid === "" || ele.maxBid === null) &&
              parseInt(ele.interestedToBid) === 1
          )
          .map((ele, index) => ele === true && index + 1)
          .filter((ele) => ele !== false);
        CustomToast.error(
          "Please enter Max Bid value in row no. " + rowinvalid + " "
        );
        return false;
      }

      if (
        data?.length > 0 &&
        data?.filter((ele) => !/^[0-9]+$/?.test(ele.maxBid?.toString()))
          ?.length > 0
      ) {
        CustomToast.error(
          `Max Bid cannot have decimal value in row no. ${data
            ?.map((ele) => !/^[0-9]+$/?.test(ele.maxBid?.toString()))
            .map((ele, index) => ele === true && index + 1)
            .filter((ele) => ele !== false)
            ?.join(", ")}`
        );
        // //debugger;
        return false;
      }

      savedata = data
        .filter((items) =>
          parseInt(items.maxBidId) === 0
            ? parseInt(items.interestedToBid) !== 0
            : items
        )
        .filter((ele) => !(ele.flag === 1 || ele.EditFlag === 0))
        .map((items) => {
          const Newdatas = {
            auctionCenterId: auctionCenterId,
            LotNo: items?.LotNo?.toString(),
            interestedToBid: parseInt(items.interestedToBid),
            maxBid:
              parseInt(items.interestedToBid) === 0
                ? 0
                : parseInt(items.maxBid),
            maxBidId:
              items.maxBidId === "" || items.maxBidId === null
                ? 0
                : parseInt(items.maxBidId),
            //sessiontype:sessionType?.toString(),
            isActive: true,
            createdBy: userId,
            updatedBy: userId,
            buyerUserId: userId,
            status: items.status === "Submitted" ? 1 : 0,
            sessionTypeName:
              items.sessionTypeName !== null
                ? items.sessionTypeName.toString()
                : "",
          };
          return Newdatas;
          //   const Newdatas = {
          //     SaleProgramId: parseInt(items.SaleProgramId),
          //     auctionCenterId: auctionCenterId,
          //     kutchaCatalogId: parseInt(items.KutchaCatalogId),
          //     sessionTypeId: parseInt(items.sessionTypeId),
          //     teaTypeId: parseInt(items.teaTypeId),
          //     categoryId: parseInt(items.categoryId),
          //     markId: parseInt(items.markId),
          //     gradeId: parseInt(items.gradeId),
          //     invoiceId: parseInt(items.invoiceId),
          //     auctionCatalogId: parseInt(items.auctionCatalogId),
          //     interestedToBid: parseInt(items.interestedToBid),
          //     maxBid: parseInt(items.maxBid),
          //     isActive: true,
          //     createdBy: 2,
          //     updatedBy: 2,
          //     buyerUserId:userId,
          //     status: 1, // parseInt(items.status),
          //     LotNo: items.LotNo,
          //   };
          //   return Newdatas;
        });
      axiosMain
        // .post("/preauction/MaxBidEntry/UpdateMaxBidEntry", savedata)
        .post(
          `/preauction/${
            auctionType === "ENGLISH"
              ? "EnglishAuctionMaxBidEntry"
              : "MaxBidEntry"
          }/UploadMaxBidEntry?dataFlag=Menual&season=` +
            formikval.season +
            "&saleNo=" +
            formikval.saleNo,
          savedata
        )
        .then((response) => {
          setValidationErrormessages({});
          if (response.data.statusCode == 200) {
            CustomToast.success(response.data.message);
            getMaxbid();
          } else {
            CustomToast.error(response.data.message);
            return false;
          }

          // Handle the successful response here
          // console.log("Response:", response.data);
        })
        .catch((error) => {
          // Handle any errors here
          console.error("Error:", error);
        });
    }
  };
  const newhandleCheckboxChange = (itemId) => {
    const updatedSelection = selectedRows.includes(itemId)
      ? selectedRows.filter((id) => id !== itemId)
      : [...selectedRows, itemId];
    setSelectedRows(updatedSelection);
  };
  const handleSaveCell = (id, field, value, itemnew) => {
    if (field === "interestedToBid") {
      itemnew = { ...itemnew, [field]: value !== "" ? parseInt(value) : 0 };
      // if (value !== "" ? parseInt(value) : 0 === 0) {
      //   itemnew = { ...itemnew, ...itemnew.maxBid= 0 };
      // }
    } else if (field === "maxBid") {
      itemnew = { ...itemnew, [field]: value !== "" ? parseInt(value) : 0 };
    } else itemnew = { ...itemnew, [field]: value.toString() };

    // console.log(id, field, value, itemnew, "id, field, value");
    if (
      field?.toString() === "SampleQty" ||
      field?.toString() === "grossKgs" ||
      field?.toString() === "shortExcessWeight" ||
      field?.toString() === "basePrice" ||
      field?.toString() === "maxBid"
    ) {
      // if (!/^[0-9]+$/?.test(value.toString())) {
      //   setValidationErrormessages([
      //     ...validationErrormessages,
      //     {
      //       id,
      //     },
      //   ]);
      //   setData((prevData) =>
      //     prevData.map((item) =>
      //       item.LotNo === id ? { ...item, [field]: value } : item
      //     )
      //   );
      //   setSelectedData((prevData) =>
      //     prevData.map((item) =>
      //       item.LotNo === id ? { ...item, [field]: value } : item
      //     )
      //   );
      //   // //debugger;

      //   return false;
      // } else {
      //   setValidationErrormessages([]);
      //   setData((prevData) =>
      //     prevData.map((item) =>
      //       item.LotNo === id ? { ...item, [field]: value } : item
      //     )
      //   );
      //   setSelectedData((prevData) =>
      //     prevData.map((item) =>
      //       item.LotNo === id ? { ...item, [field]: value } : item
      //     )
      //   );
      // }
      // //debugger;
      let isValid = /^\d+(\.\d{1,2})?$/.test(value.toString());
      if (isValid) {
        setData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id ? { ...item, [field]: value } : item
          )
        );
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [field]: "",
        }));
      } else {
        setData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id ? { ...item, [field]: value } : item
          )
        );
        // // console.log("Sample Qwantity is able to dasimal");
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [field]: "Two digits after decimal point allowed.",
        }));
        return;
      }
    }
    if (field?.toString() === "grossKgs") {
      const dataList = data.filter((item) => item.LotNo === id)?.at(0);

      let greatestValue = Math.max(
        parseFloat(value),
        parseFloat(dataList.SampleQty)
      );

      if (
        greatestValue === parseFloat(value) &&
        parseFloat(value) !== parseFloat(dataList.SampleQty)
      ) {
        let netKgsValue = value - dataList.tareKgs;

        let noOfKgs = dataList.totalPackages * netKgsValue;
        let smapQty = dataList.SampleQty + dataList.shortExcessWeight;
        setData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id
              ? {
                  ...item,
                  [field]: value,
                  netKgs: value - dataList.tareKgs,
                  invoiceWeight: noOfKgs - smapQty,
                }
              : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id
              ? {
                  ...item,
                  [field]: value,
                  netKgs: value - dataList.tareKgs,
                  invoiceWeight: noOfKgs - smapQty,
                }
              : item
          )
        );
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          grossKgs: "",
        }));
      } else {
        setData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id
              ? { ...item, [field]: value, netKgs: 0, invoiceWeight: 0 }
              : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id
              ? { ...item, [field]: value, netKgs: 0, invoiceWeight: 0 }
              : item
          )
        );
        // // console.log("Sample Qwantity is able to dasimal");
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          grossKgs: "Gross Weight cannot be less than sampling Qty.",
        }));
      }

      // console.log(
      //   parseFloat(dataList.SampleQty),
      //   field,
      //   "dataListdataListdataList"
      // );
    } else {
      // // console.log(data);
      //set DATA from Here
      setData((prevData) =>
        prevData.map((item) =>
          item.LotNo === id ? { ...item, [field]: value } : item
        )
      );
      setSelectedData((prevData) =>
        prevData.map((item) =>
          item.LotNo === id ? { ...item, [field]: value } : item
        )
      );
    }

    if (
      field?.toString() === "auctioneerValuation" ||
      field?.toString() === "markPackageComments" ||
      field?.toString() === "lotComments" ||
      field?.toString() === "qualityComments"
    ) {
      const regex = /^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/\-|]+$/;

      if (regex.test(value) || value === "") {
        setData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id ? { ...item, [field]: value } : item
          )
        );
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [field]: "",
        }));
      } else {
        setData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.LotNo === id ? { ...item, [field]: value } : item
          )
        );
        // // console.log("Sample Qwantity is able to dasimal");
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [field]: "Two digits after decimal point allowed.",
        }));
        return;
      }
    }
    const index = data.findIndex((item) => item.LotNo === itemnew.LotNo);

    if (index !== -1) {
      data.splice(index, 1, { ...data[index], [field]: value });
    }

    if (field.toString() === "buyingQty") {
      data.splice(index, 1, {
        ...data[index],
        sharingQty: data[index]?.totalPackages - value,
      });
    }

    setSelectedData(data.map((item) => (item.LotNo === id ? itemnew : item)));
    // console.log("value updated:", value);
    // console.log("Data updated:", data);
    // console.log("SelectedData updated:", selectedData);
    // if (!value) {
    //   setValidationErrors((prevErrors) => ({
    //     ...prevErrors,
    //     [field]: "Field is required.",
    //   }));
    //   return;
    // }

    // setValidationErrors((prevErrors) => ({
    //   ...prevErrors,
    //   [field]: "", // Clear the error message
    // }));
  };
  // const handleSaveCell = (id, field, value) => {
  //   setData((prevData) =>
  //     prevData.map((item) =>
  //       item.LotNo === id ? { ...item, [field]: value } : item
  //     )
  //   );
  // };

  // Extract property names from the first data object
  const propertyNames =
    auctionType === "ENGLISH"
      ? [
          "LotNo",
          "teaTypeName",
          "categoryName",
          "markName",
          "gradeName",
          "invoiceNo",
          "totalPackages",
          "basePrice",
          // "priceIncrement",
          "LSP_SP",
          "sharingQty",
          "buyingQty",
          "minAcceptableQty",
          "AutoBidLimit",
          "LimitPrice",
          "status",
          "createdBy",
          "lastModifiedBy",
          "sessionTypeName",
        ]
      : [
          "LotNo",
          "teaTypeName",
          "categoryName",
          "markName",
          "gradeName",
          // "invoiceNo",
          "basePrice",
          "basePrice",
          "priceIncrement",
          "LSP_SP",
          "interestedToBid",
          "maxBid",
          "invoiceNo",
          "totalPackages",
          "createdBy",
          "lastModifiedBy",
          "sessionTypeName",
          "status",
        ];
  const nonEditableColumns =
    auctionType === "ENGLISH"
      ? [
          "LotNo",
          "teaTypeName",
          "categoryName",
          "markName",
          "gradeName",
          "invoiceNo",
          "basePrice",
          "totalPackages",
          // "priceIncrement",
          "LSP_SP",
          "sharingQty",
          "minAcceptableQty",
          "status",
          "createdBy",
          "lastModifiedBy",
          "sessionTypeName",
        ]
      : [
          "LotNo",
          "teaTypeName",
          "categoryName",
          "markName",
          "gradeName",
          // "invoiceNo",
          "basePrice",
          "basePrice",
          "priceIncrement",
          "LSP_SP",
          //"interestedtobid",
          //"maxbid",
          "invoiceNo",
          "totalPackages",
          "createdBy",
          "updatedBy",
          "sessionTypeName",
          "status",
        ]; // Add column names that are not editable

  useEffect(() => {
    dispatch(fetchMarkTypeRequest());
    // dispatch(fetchWarehouseUserRequest({ auctionCenterId }));

    //     dispatch(fetchSubTeaTypeRequest(formik.values.teaType));
  }, []);

  const markType = useSelector((state) => state.mark.markTypeData.responseData);

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("dragIndex", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData("dragIndex");
    const updatedColumns = [...columns];
    const draggedColumn = updatedColumns.splice(dragIndex, 1)[0];
    updatedColumns.splice(dropIndex, 0, draggedColumn);
    setColumns(updatedColumns);
  };
  return (
    <div>
      <div>Total Count : {rows?.length}</div>
      <div
        style={{
          overflowX: "auto",
          overflowY: "auto",
          maxHeight: "400px",
          maxWidth: "100%",
          border: "1px solid #ccc",
          whiteSpace: "nowrap",
        }}
        className="TableBox normal-table"
      >
        <table
          className="resizable-columns-table"
          style={{
            borderCollapse: "collapse",
            width: "100%",
            minWidth: "600px",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  position: "sticky",
                  left: 0,
                  background: "#fff",
                  zIndex: 10,
                  borderRight: "1px solid #ddd",
                  padding: "10px",
                  resize: "none",
                  width: "300px",
                }}
              >
                Lot No.
              </th>
              {columns.map((column, index) => (
                <th
                  key={index}
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDragOver={handleDragOver}
                  onDrop={(e) => handleDrop(e, index)}
                  style={{ width: "200px" }}
                >
                  <div className="resizable-columns"> {column.label}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows?.length > 0 ? (
              data?.map((item, index) =>
                auctionType === "ENGLISH" ? (
                  <tr
                    key={index}
                    onClick={() => newhandleCheckboxChange(item.LotNo)}
                    style={{
                      backgroundColor: selectedRows.includes(item.LotNo)
                        ? "#f0f0f0"
                        : "transparent",
                    }}
                  >
                    <td
                      style={{
                        position: "sticky",
                        left: 0,
                        background: "#e5e5e5f2",
                        zIndex: 10,
                        borderRight: "1px solid #ddd",
                        padding: "10px",
                        resize: "none",
                        width: "300px",
                      }}
                    >
                      {item.LotNo}
                    </td>
                    {columns
                      ?.map((ele) => ele.id)
                      ?.map((propertyName, index) => (
                        <td key={index}>
                          {nonEditableColumns.includes(propertyName) ? (
                            item[propertyName]
                          ) : propertyName === "lastModifiedBy" ? (
                            item[propertyName]
                          ) : propertyName.includes("buyingQty") ? (
                            <input
                              disabled={
                                item.flag === 1 || item.EditFlag === 0
                                  ? true
                                  : false
                              }
                              type="text"
                              value={item[propertyName]}
                              onFocus={(e) => {
                                if (e.target.value === "0") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "",
                                    item
                                  );
                                  e.target.value = e.target.value.replace(
                                    /^0+/,
                                    ""
                                  ); // Remove leading zeros on click
                                }
                              }}
                              onBlur={(e) => {
                                if (e.target.value.trim() === "") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "0",
                                    item
                                  );
                                  e.target.value = "0"; // Reset to zero if left blank
                                }
                              }}
                              onChange={(e) => {
                                // if (parseInt(e.target.value) === 0) {
                                //   CustomToast.error(
                                //     "BQ@HBP cannot be ZERO in Lot No. " +
                                //       item.LotNo
                                //   );
                                // } else {
                                // //debugger;
                                // if (/^[0-9]+$/.test(e.target.value)) {
                                if (
                                  parseInt(e.target.value) > item.totalPackages
                                ) {
                                  handleCheckboxChange(item.LotNo);

                                  // if (e.target.value === "") {
                                  //   handleSaveCell(
                                  //     item.LotNo,
                                  //     propertyName,
                                  //     "",
                                  //     item
                                  //   );
                                  // } else {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    item.totalPackages,
                                    item
                                  );
                                  // }
                                } else {
                                  handleCheckboxChange(item.LotNo);
                                  let value = e.target.value;
                                  if (value === "") {
                                    handleSaveCell(
                                      item.LotNo,
                                      propertyName,
                                      "",
                                      item
                                    );
                                    return;
                                  }
                                  if (
                                    /^[0-9]+$/.test(value) &&
                                    !(value.length > 1 && value.startsWith("0"))
                                  ) {
                                    handleSaveCell(
                                      item.LotNo,
                                      propertyName,
                                      value,
                                      item
                                    );
                                  } else {
                                    e.target.value = value.replace(/^0+/, ""); // Remove leading zeros dynamically
                                  }
                                  // else {
                                  //   handleSaveCell(
                                  //     item.LotNo,
                                  //     propertyName,
                                  //     e.target.value,
                                  //     item
                                  //   );
                                  // }
                                }
                                // }
                                // }
                              }}
                            />
                          ) : propertyName.includes("AutoBidLimit") ? (
                            <input
                              disabled={
                                item.flag === 1 || item.EditFlag === 0
                                  ? true
                                  : false
                              }
                              type="text"
                              value={
                                item.AutoBidLimit === 0 ||
                                item.AutoBidLimit === "0"
                                  ? 0
                                  : item[propertyName]
                              }
                              onFocus={(e) => {
                                if (e.target.value === "0") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "",
                                    item
                                  );
                                  e.target.value = e.target.value.replace(
                                    /^0+/,
                                    ""
                                  ); // Remove leading zeros on click
                                }
                              }}
                              onBlur={(e) => {
                                if (e.target.value.trim() === "") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "0",
                                    item
                                  );
                                  e.target.value = "0"; // Reset to zero if left blank
                                }
                              }}
                              onInput={(e) => {
                                handleCheckboxChange(item.LotNo);
                                let value = e.target.value;
                                // if (
                                //   parseInt(e.target.value) === -1 ||
                                //   isNaN(parseInt(e.target.value))
                                // ) {
                                //   setTimeout(() => {
                                //     CustomToast.error(
                                //       "Please enter Auto Bid in Lot No. " +
                                //         item.LotNo
                                //     );
                                //   }, 1000);
                                // } else {
                                if (value === "") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "",
                                    item
                                  );
                                  return;
                                }

                                if (
                                  /^[0-9]+$/.test(value) &&
                                  !(value.length > 1 && value.startsWith("0"))
                                ) {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    value,
                                    item
                                  );
                                } else {
                                  e.target.value = value.replace(/^0+/, ""); // Remove leading zeros dynamically
                                }
                                // }
                              }}
                            />
                          ) : propertyName.includes("LimitPrice") ? (
                            <input
                              disabled={
                                item.flag === 1 || item.EditFlag === 0
                                  ? true
                                  : false
                              }
                              type="text"
                              value={
                                item.LimitPrice === 0 || item.LimitPrice === "0"
                                  ? 0
                                  : item[propertyName]
                              }
                              // onInput={(e) => {
                              //   handleCheckboxChange(item.LotNo);
                              //   if (
                              //     /^[0-9]+$/.test(e.target.value) ||
                              //     e.target.value === ""
                              //   ) {
                              //     handleSaveCell(
                              //       item.LotNo,
                              //       propertyName,
                              //       e.target.value === ""
                              //         ? "0"
                              //         : e.target.value,
                              //       item
                              //     );
                              //   }
                              // }}
                              onFocus={(e) => {
                                if (e.target.value === "0") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "",
                                    item
                                  );
                                  e.target.value = e.target.value.replace(
                                    /^0+/,
                                    ""
                                  ); // Remove leading zeros on click
                                }
                              }}
                              onBlur={(e) => {
                                if (e.target.value.trim() === "") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "0",
                                    item
                                  );
                                  e.target.value = "0"; // Reset to zero if left blank
                                }
                              }}
                              onInput={(e) => {
                                handleCheckboxChange(item.LotNo);
                                let value = e.target.value;

                                // Allow empty input (don't force "0")
                                if (value === "") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "",
                                    item
                                  );
                                  return;
                                }

                                // Allow only numbers and prevent leading zeros (except "0" alone)
                                if (
                                  /^[0-9]+$/.test(value) &&
                                  !(value.length > 1 && value.startsWith("0"))
                                ) {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    value,
                                    item
                                  );
                                } else {
                                  e.target.value = value.replace(/^0+/, ""); // Remove leading zeros dynamically
                                }
                              }}
                            />
                          ) : (
                            <select
                              disabled={
                                item.flag === 1 || item.EditFlag === 0
                                  ? true
                                  : false
                              }
                              value={item[propertyName]}
                              onChange={(e) => {
                                handleCheckboxChange(item.LotNo);
                                handleSaveCell(
                                  item.LotNo,
                                  propertyName,
                                  e.target.value,
                                  item
                                );
                              }}
                            >
                              <option value="0">N</option>
                              <option value="1">Y</option>
                            </select>
                          )}
                        </td>
                      ))}
                  </tr>
                ) : (
                  <tr
                    key={item.LotNo}
                    onClick={() => newhandleCheckboxChange(item.LotNo)}
                    style={{
                      backgroundColor: selectedRows.includes(item.LotNo)
                        ? "#f0f0f0"
                        : "transparent",
                    }}
                  >
                    {/* <td>
                  <input
                    type="checkbox"
                    checked={selectedData.some(
                      (selectedItem) =>
                        selectedItem.KutchaCatalogId === item.LotNo
                    )}
                    onChange={() => {
                      setChecked(!checked);

                      handleCheckboxChange(item.LotNo);
                    }}
                  />
                </td> */}
                    <td
                      style={{
                        position: "sticky",
                        left: 0,
                        background: "#e5e5e5f2",
                        zIndex: 10,
                        borderRight: "1px solid #ddd",
                        padding: "10px",
                        resize: "none",
                        width: "300px",
                      }}
                    >
                      {item.LotNo}
                    </td>
                    {columns
                      ?.map((ele) => ele.id)
                      ?.map((propertyName, index) => (
                        <td key={index}>
                          {nonEditableColumns.includes(propertyName) ? (
                            item[propertyName]
                          ) : propertyName === "lastModifiedBy" ? (
                            item[propertyName]
                          ) : propertyName === "maxBid" ? (
                            <input
                              disabled={
                                item.flag === 1 || item.EditFlag === 0
                                  ? true
                                  : false
                              }
                              type="text"
                              value={
                                item.interestedToBid === 0 ||
                                item.interestedToBid === "0"
                                  ? 0
                                  : item[propertyName]
                              }
                              onFocus={(e) => {
                                if (e.target.value === "0") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "",
                                    item
                                  );
                                  e.target.value = e.target.value.replace(
                                    /^0+/,
                                    ""
                                  ); // Remove leading zeros on click
                                }
                              }}
                              onBlur={(e) => {
                                if (e.target.value.trim() === "") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "0",
                                    item
                                  );
                                  e.target.value = "0"; // Reset to zero if left blank
                                }
                              }}
                              onInput={(e) => {
                                handleCheckboxChange(item.LotNo);
                                let value = e.target.value;
                                if (value === "") {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    "",
                                    item
                                  );
                                  return;
                                }

                                // Allow only numbers and prevent leading zeros (except "0" alone)
                                if (
                                  /^[0-9]+$/.test(value) &&
                                  !(value.length > 1 && value.startsWith("0"))
                                ) {
                                  handleSaveCell(
                                    item.LotNo,
                                    propertyName,
                                    value,
                                    item
                                  );
                                } else {
                                  e.target.value = value.replace(/^0+/, ""); // Remove leading zeros dynamically
                                }

                                // handleSaveCell(
                                //   item.LotNo,
                                //   propertyName,
                                //   e.target.value,
                                //   item
                                // );
                              }}
                            />
                          ) : (
                            <select
                              disabled={
                                item.flag === 1 || item.EditFlag === 0
                                  ? true
                                  : false
                              }
                              value={item[propertyName]}
                              onChange={(e) => {
                                handleCheckboxChange(item.LotNo);
                                handleSaveCell(
                                  item.LotNo,
                                  propertyName,
                                  e.target.value,
                                  item
                                );
                              }}
                            >
                              <option value="0">N</option>
                              <option value="1">Y</option>
                            </select>
                          )}
                        </td>
                      ))}
                  </tr>
                )
              )
            ) : (
              <tr>
                <td colSpan={53}>
                  <div className="NoData">No Records Found</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="BtnGroup">
            {modalRight?.includes("2") && rows?.length > 0 ? (
              <div className="row">
                <div className="col-12">
                  <div className="BtnGroup">
                    <button
                      className="SubmitBtn"
                      disabled={
                        rows?.length ===
                        rows?.filter(
                          (item) => item.flag === 1 || item.EditFlag === 0
                        )?.length
                      }
                      type="button"
                      onClick={savetabledata}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            Limit Price is less than Auto Bid Price or Bid Price. Do you want to
            continue?
          </Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body> */}
        <Modal.Footer>
          <div className="BtnGroup">
            <button variant="primary" onClick={() => handleAdd(true)}>
              Yes
            </button>
            <button variant="secondary" onClick={handleClose}>
              No
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* new modal */}
      <Modals
        size="xl"
        title={openConformaionModalmsg?.message}
        show={openConformaionModal}
        handleClose={() => {
          setOpenConformaionModal(false);
        }}
      >
        <div>
          <ul
            style={{
              listStyle: "disc",
              padding: "25px",
              textAlign: "justify",
            }}
          >
            {openConformaionModalmsg?.responseData?.map((ele, index) => (
              <li>{ele.invalidLots}</li>
            ))}
          </ul>
        </div>
      </Modals>
    </div>
  );
};

export default MaxBidEntryTable;
